'use client';

import { c as _c } from "react/compiler-runtime";
import { SvgChevrondown } from '@common/icon';
import { cn } from '@core/utils';
import { useRef, useState } from 'react';
import type { FaqItem, MedianIncomeYear } from '../constants';
import { MEDIAN_INCOME_BY_YEAR } from '../constants';
interface FaqListProps {
  year: MedianIncomeYear;
}

/**
 * ⑨ FAQ — 자주 묻는 질문. scrollHeight 기반 height + opacity 트랜지션으로 부드럽게 펼침.
 */
export const FaqList = t0 => {
  const $ = _c(14);
  const {
    year
  } = t0;
  const {
    faqList,
    source
  } = MEDIAN_INCOME_BY_YEAR[year];
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h2 className="font-700 text-Gray-900 typo-h5 mobile-tablet:typo-h6">자주 묻는 질문</h2>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== faqList.length) {
    t2 = <p className="text-Gray-700 typo-body4">중위소득·기초생활보장에 대한 핵심 질문 {faqList.length}가지를 정리했습니다.</p>;
    $[1] = faqList.length;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== faqList) {
    t3 = faqList.map(_temp);
    $[3] = faqList;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <div className="flex flex-col">{t3}</div>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <strong className="font-700 text-Gray-700">출처:</strong>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== source) {
    t6 = <p className="text-Gray-600 typo-caption1">{t5} {source} / 통계청 가계금융복지조사</p>;
    $[8] = source;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t2 || $[11] !== t4 || $[12] !== t6) {
    t7 = <section className="flex flex-col gap-12 mobile-tablet:px-16">{t1}{t2}{t4}{t6}</section>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};
interface FaqRowProps {
  index: number;
  item: FaqItem;
}
const FaqRow = ({
  index,
  item
}: FaqRowProps) => {
  const [opened, setOpened] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);
  // eslint-disable-next-line react-hooks/refs -- 아코디언 scrollHeight 측정 패턴, 리팩터 시 회귀 이력 있음
  const height = opened ? contentRef.current?.scrollHeight ?? 0 : 0;
  return <div className="border-b-1 border-Gray-100 last:border-b-0">
      <button type="button" aria-expanded={opened} onClick={() => setOpened(prev => !prev)} className="flex w-full cursor-pointer items-center justify-between gap-12 bg-transparent py-16 text-left font-600 text-Gray-900 typo-body4">
        <span>
          Q{index + 1}. {item.q}
        </span>
        <SvgChevrondown aria-hidden="true" className={cn('size-16 shrink-0 text-Gray-500 transition-transform duration-200', opened && 'rotate-180')} />
      </button>
      <div className="overflow-hidden transition-[height] duration-300"
    // eslint-disable-next-line react-hooks/refs -- 아코디언 scrollHeight 기반 height 적용, 리팩터 시 회귀 이력 있음
    style={{
      height
    }}>
        <div ref={contentRef} className={cn('pb-16 text-Gray-700 transition-opacity duration-300 typo-body4', opened ? 'opacity-100' : 'opacity-0')} dangerouslySetInnerHTML={{
        __html: item.a
      }} />
      </div>
    </div>;
};
function _temp(f, idx) {
  return <FaqRow key={f.q} index={idx} item={f} />;
}